"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBApiProductOwner", {
  enumerable: true,
  get: function get() {
    return _SVBApiProductOwner.default;
  }
});
var _SVBApiProductOwner = _interopRequireDefault(require("./src/SVBApiProductOwner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }